// src/services/UnidadeApi.js
import axiosInstance from "./axiosInstance";

export default class UnidadeApi {
  async getUnidades() {
    try {
      const { data } = await axiosInstance.get(`${process.env.VUE_APP_BASE_API_URL}/api/v1/unidades`);
      return data;
    } catch (error) {
      console.error("Erro ao buscar unidades:", error);
      throw error;
    }
  }
}